import './title.scss'
import clsx from 'clsx'

interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
    children: React.ReactNode
    classname?: string
}

export const Title = ({ children, classname }: TitleProps) => {
    return <h3 className={clsx('title', classname)}>{children}</h3>
}
